/**
 * 大转盘枚举
 */
export const BigWheelConstants = {
  /**
   * 活动类型，目前一共有9种，如大转盘，自定义表单，专题活动等
   */
  ActivityType: {
    /**
     * "4": 门店导航
     */
    storeNavigation: "4",

    /**
     * "5": 自定义表单
     */
    customForm: "5",

    /**
     * "6": 积分兑换活动
     */
    pointConversion: "6",

    /**
     * "7": 专题活动
     */
    thematicActivity: "7",

    /**
     * "8": 活动编排
     */
    activityArrangement: "8",

    /**
     * "9": 大转盘
     */
    bigTurnable: "9",

    /**
     * "10": 新品预约
     */
    newProductsReservation: "10",
    /**
     * "11": NPS模板活动
     */
    NPSTemplateActivity: "11",
    /**
     * "12": 签到
     */
    signIn: "12"
  },

  /**
   * 活动状态：一共有4种状态：0-未开始，1-进行中，2-已暂停，3-已结束
   */
  ActivityStatus: {
    /**
     * "0": 未开始
     */
    notStarted: "0",

    /**
     * "1": 进行中
     */
    running: "1",

    /**
     * "2": 已暂停
     */
    paused: "2",

    /**
     * "3": 已结束
     */
    finished: "3"
  },

  /**
   * 自定义表单类型，包括：0-普通表单，1-话题PK，2-趣味表单
   */
  FormType: {
    /**
     * "0": 普通表单
     */
    commonForm: "0",

    /**
     * "1": 话题PK
     */
    topicPK: "1",

    /**
     * "2": 趣味表单
     */
    interestForm: "2"
  },

  /**
   * 活动样式，包括：1-大转盘，2-盲盒，3-轮盘锦鲤（老虎机），4-新盲盒
   */
  BigWheelActivityType: {
    /**
     * "1": 大转盘
     */
    bigTurnable: "1",

    /**
     * "2": 盲盒
     */
    blindBox: "2",

    /**
     * "3": 轮盘锦鲤（老虎机）
     */
    tigerMachine: "3",

    /**
     * "4": 新盲盒
     */
    newBlindBox: "4"
  },

  /**
   * 抽奖类型，包括：1-普通抽奖，2-整点购抽奖，3-定时开奖
   */
  DrawWheelType: {
    /**
     * "1": 普通抽奖
     */
    ordinaryDraw: "1",

    /**
     * "2": 整点购抽奖
     */
    purchaseOnHourDraw: "2",

    /**
     * "3": 定时开奖
     */
    timedDraw: "3"
  },

  /**
   * 奖品类型，包括：0-未中奖，1-虚拟奖品，2-实物奖品，3-优惠券，4-积分，5-代金券，6-赠品券
   */
  GoodsType: {
    /**
     * "0": 未中奖
     */
    noAward: "0",

    /**
     * "1": 虚拟奖品
     */
    virtualAward: "1",

    /**
     * "2": 实物奖品
     */
    entityAward: "2",

    /**
     * "3": 优惠券
     */
    coupon: "3",

    /**
     * "4": 积分
     */
    accumulatePoints: "4",

    /**
     * "5": 代金券
     */
    voucher: "5",

    /**
     * "6": 赠品券
     */
    giftCoupon: "6"
  },

  /**
   * 奖品领取类型，包括：1-邮寄(实物)/线上兑换(虚拟)，2-到店自提(实物)/线下核销(虚拟)，3-线下核销发串码(虚拟)) ，4-免单抽奖，5-货柜自取
   */
  CollectionType: {
    /**
     * "1": 邮寄(实物)/线上兑换(虚拟)
     */
    expressOrOnlineCheckOff: "1",

    /**
     * "2": 到店自提(实物)/线下核销(虚拟)
     */
    inStore: "2",

    /**
     * "3": 线下核销发卡密(虚拟))
     */
    checkOffStrCode: "3",

    /**
     * "4": 免单抽奖
     */
    freeOfCharge: "4",

    /**
     * "5": 货柜自取
     */
    containerPickup: "5"
  },

  /**
   * 定时开奖状态，包括：
   * 1-活动已结束,用户有中奖，
   * 2-活动已结束,用户未中奖，
   * 3-活动已结束,但是用户未参与过活动，
   * 4-活动进行中,用户无抽奖次数，
   * 5-活动进行中,用户有抽奖次数，
   * 6-活动已结束,但是活动中奖逻辑还在计算中(开奖中)
   */
  RegularDrawShowStatus: {
    /**
     * "1": 活动已结束,用户有中奖
     */
    winPrizes: "1",

    /**
     * "2": 活动已结束,用户未中奖
     */
    failToWin: "2",

    /**
     * "3": 活动已结束,但是用户未参与过活动
     */
    noParticipate: "3",

    /**
     * "4": 活动进行中,用户无抽奖次数
     */
    noChance: "4",

    /**
     * "5": 活动进行中,用户有抽奖次数
     */
    hasChance: "5",

    /**
     * "6": 活动已结束,但是活动中奖逻辑还在计算中(开奖中)
     */
    runningLotteries: "6"
  },

  /**
   * 小程序类型，包括：1-HI荣耀小程序，2-直营店小程序
   */
  MiniType: {
    /**
     * "1": HI荣耀小程序
     */
    HiHonor: "1",

    /**
     * "2": 直营店小程序
     */
    HonorBrand: "2"
  },

  /**
   * 用户类型，包括："1": 荣耀会员；"2": 全部用户；"3"：社群用户
   */
  UserType: {
    /**
     * "1": 荣耀会员
     */
    honorVIP: "1",

    /**
     * "2": 全部用户
     */
    allUser: "2",
    /**
     *  "3"：社群用户
     */
    communityUser: "3"
  },

  flag: {
    flagTrue: "1",
    flagFalse: "0"
  },

  /**
   * 获取抽奖次数方式，包括： initDraw-初始可抽奖，orderDraw-订单抽奖，pointDraw-积分抽奖
   */
  DrawType: {
    /**
     * initDraw：初始可抽奖
     */
    InitDraw: "initDraw",
    /**
     * orderDraw：订单抽奖
     */
    OrderDraw: "orderDraw",
    /**
     * pointDraw：积分抽奖
     */
    PointDraw: "pointDraw"
  },
  /**
   * 登录方式，包括"wechat"-微信，"Alipay"-支付宝，
   */
  LoginType: {
    /**
     * "wechat"：微信
     */
    Wechat: "wechat",
    /**
     * "Alipay"：支付宝
     */
    Alipay: "Alipay",
    /**
     * 全部登录类型，即微信+支付宝，需使用方法isAllLogin判断，该枚举值仅做参考
     */
    All: "wechat,Alipay",
    /**
     * "none"：无需登录
     */
    None: "none"
  },
  /**
   * 获取抽奖机会的类型，包括，1 初始化抽奖，2 积分抽奖 3 全部  4 订单抽奖 5 每日抽奖 6 分享抽奖 7 助力抽奖。
   * 若有多种，则以英文逗号分隔，如'1,2'：表示初始化抽奖+积分抽奖
   */
  ParticipateType: {
    /**
     * '1'：初始化抽奖
     */
    InitDraw: "1",
    /**
     * '2'：积分抽奖
     */
    PointsDraw: "2",
    /**
     * '3'：全部
     */
    all: "3",
    /**
     * '4'：订单抽奖
     */
    OrdersDraw: "4",
    /**
     * '5'：每日抽奖
     */
    DailyDraw: "5",
    /**
     * '6'：分享抽奖
     */
    ShareDraw: "6",
    /**
     * '7'：助力抽奖
     */
    AssistDraw: "7"
  },

  /**
   * 跳转方式('0'-小程序代金券列表,不涉及代金券、'1'-小程序首页、'2'-自定义链接、'3'-入会好礼奖品默认页面、'4'-小程序优惠券列表、'9'-无跳转)
   */
  JumpType: {
    /**
     * "0"：小程序代金券列表
     */
    voucherList: "0",
    /**
     * "1"：小程序首页
     */
    MPIndex: "1",
    /**
     * "2"：自定义链接
     */
    customLink: "2",
    /**
     * "3"：入会好礼奖品默认页
     */
    membershipBenefits: "3",
    /**
     * "4"：小程序优惠券列表
     */
    couponList: "4",
    /**
     * "9"：无跳转
     */
    noJump: "9"
  },
  /**
   * 非社群用户引导入群方式设置(0不设置, 1设置-活码地址, 2设置-自定义)
   */
  communityJoinPathConfig: {
    /**
     * 0不设置
     */
    noSetting: "0",
    /**
     * 1设置-活码地址
     */
    setLiveCode: "1",
    /**
     * 2设置-自定义
     */
    setCustomizeLink: "2"
  },
  /**
   * 预约导购标识，包括："1"：需要预约导购（可能，还需结合奖品类型和领取方式进行判断），"0"：不需要预约导购
   */
  appointmentFlag: {
    /**
     * "1"：需要预约导购（可能，还需结合奖品类型和领取方式进行判断）
     */
    need: "1",
    /**
     * "0"：不需要预约导购
     */
    noNeed: "0"
  },
  /**
   * 中奖滚动展示标识 0: 展示 1: 不展示，是否显示滚动栏，该值同时控制【中奖名单】按钮是否显示，逻辑与滚动栏相反
   * 即，0：不展示【中奖名单】按钮，1：展示【中奖名单】按钮
   */
  prizeWinningScrollFlag: {
    /**
     * 0: 展示滚动栏，不展示【中奖名单】按钮
     */
    display: 0,
    /**
     * 1: 不展示滚动栏，展示【中奖名单】按钮
     */
    hidden: 1
  },
  /**
   * 是否被活动编排引用 ,'1'：被引用了，'0'：没有被引用
   */
  isUsed: {
    /**
     * '1'：被引用了
     */
    yes: "1",
    /**
     * '0'：没有被引用
     */
    no: "0"
  },
  /**
   * 当前用户的抽奖状态（查询次数接口：getDrawInfo，返回）
   * 0:成功（即可抽奖）; 1:活动未开始; 2:活动已结束; 3:超过该活动用户可参与总次数;
   * 4:未超过该活动用户可参与总次数，但超过该活动用户今日可参与总次数; 5:历史失败的逻辑（远程调用失败等异常场景）；
   * 6:不是会员; 7:积分不足
   */
  status: {
    /**
     * 0:成功（即可抽奖）
     */
    canDraw: "0",
    /**
     * 1:活动未开始
     */
    notStart: "1",
    /**
     * 2:活动已结束
     */
    isOver: "2",
    /**
     * 3:超过该活动用户可参与总次数
     */
    exceedTotalTimes: "3",
    /**
     * 4:未超过该活动用户可参与总次数，但超过该活动用户今日可参与总次数
     */
    exceedDailyTimes: "4",
    /**
     * 5:历史失败的逻辑（远程调用失败等异常场景）
     */
    remoteException: "5",
    /**
     * 6:不是会员
     */
    notMember: "6",
    /**
     *  7:积分不足
     */
    notEnoughPoints: "7"
  },
  /**
   * 将要跳转的页面
   */
  jumpToPage: {
    /**
     * pointsMall：积分商城
     */
    pointsMall: "pointsMall"
  },
  /**
   * 【背景】：抽奖对象配置为社群用户，当前参与抽奖的用户是社群用户，但是不满足入会时间，
   * 【字段含义】：该活动是否配置了“不满足该活动是否需要引导用户参加其他活动”
   * 【枚举值】：'1': 开启, '0': 关闭
   */
  memberPagePathConfig: {
    /**
     * '1': 开启
     */
    open: "1",
    /**
     * '0': 关闭
     */
    close: "0"
  },
  /**
   * 是否开启“按时间段配中奖概率”: 0.关闭; 1.开启
   */
  TimeFlag: {
    /**
     * 0: 关闭
     */
    close: "0",
    /**
     * 1: 开启
     */
    open: "1"
  }
};

/**
 * 新盲盒奖品弹窗类型，包括，'1'：未中奖，'2'：积分，"3"：优惠券，"4"：代金券，"5"：实物+线上邮寄，"6"：实物+到店自提，
 * "7"：虚拟+线下核销发卡密，"8"：虚拟+线下核销，"9"：虚拟+线上兑换，"10"：赠品券
 */
export const NBBAwardPopupType = {
  /**
   * '1'：未中奖
   */
  noAward: "1",
  /**
   * '2'：积分
   */
  accumulatePoints: "2",
  /**
   * "3"：优惠券
   */
  coupon: "3",
  /**
   * "4"：代金券
   */
  voucher: "4",
  /**
   * "5"：实物+线上邮寄
   */
  entityAwardOnline: "5",
  /**
   * "6"：实物+到店自提
   */
  entityAwardInStore: "6",
  /**
   * "7"：虚拟+线下核销发卡密
   */
  virtualAwardOfflineCode: "7",
  /**
   * "8"：虚拟+线下核销
   */
  virtualAwardOffline: "8",
  /**
   * "9"：虚拟+线上兑换
   */
  virtualAwardOnline: "9",
  /**
   * '10'：赠品券
   */
  giftCoupon: "10"
};

/**
 * 自定义表单枚举
 */
export const CustomFormConstants = {
  /**
   * 自动开奖，包括:'1'-开启，'0'-关闭
   */
  automaticLottery: {
    /**
     * '1'-开启
     */
    open: "1",
    /**
     * '0'-关闭
     */
    close: "0"
  }
};

/**
 * 环境标识：包括：微信小程序、微信H5、支付宝小程序、支付宝H5、其他浏览器
 */
export const EnvMark = {
  /**
   * weixin_mp: 微信小程序
   */
  wechatMp: "weixin_mp",
  /**
   * weixin_h5: 微信H5
   */
  wechatH5: "weixin_h5",
  /**
   * alipay_mp: 支付宝小程序
   */
  alipayMp: "alipay_mp",
  /**
   * alipay_h5: 支付宝H5
   */
  alipayH5: "alipay_h5",
  /**
   * other: 其他浏览器
   */
  otherBrowser: "other"
};

/**
 * 提示语弹窗类型: utils: 使用this.$utils.tips.message, vant: vant组件弹窗Toast
 */
export const MsgDialogType = {
  /**
   * utils: 使用this.$utils.tips.message
   */
  UtilsDialog: "utils",
  /**
   * vant: vant组件弹窗Toast
   */
  VantDialog: "vant"
};

/**
 * 经纬度坐标系，"1"：wgs84大地坐标系、"2"：gcj02火星坐标系（腾讯）、"3"：bd09百度坐标系
 */
export const CoordinateType = {
  /**
   * "1"：wgs84大地坐标系
   */
  WGS84: "1",
  /**
   * "2"：gcj02火星坐标系（腾讯、高德、谷歌中国）
   */
  GCJ02: "2",
  /**
   * "3"：bd09百度坐标系
   */
  BD09: "3"
};

/**
 * 积分商城的链接类型
 */
export const PMLinkType = {
  /**
   * 短链
   */
  shortLink: "1",
  /**
   * 完整链接
   */
  fullLink: "2",

  /**
   * 未匹配
   */
  notMatch: "0"
};

/**
 * 抽奖限制  1：活动期间累计抽奖次数限制，2：活动期间每天抽奖限制
 */
export const DrawRestrictionsFlag = {
  /**
   * 累计抽奖次数
   */
  cumulativeTimes: "1",
  /**
   * 每日抽奖次数限制
   */
  everyDayTimes: "2"
};



// WEBPACK FOOTER //
// ./src/page/vibrantRubikCube/runtime/lucky-draw/common/global-variable.js